<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-cloud-parse`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M35 27a8 8 0 017.125 11.642l3.296 3.296a1 1 0 010 1.414l-1.697 1.697a1 1 0 01-1.414 0l-3.19-3.19A8 8 0 1135 27zM28 6c9.941 0 18 8.059 18 18 0 1.386-.157 2.735-.453 4.032l-3.55-3.715c.002-.106.003-.211.003-.317 0-7.732-6.268-14-14-14a14.007 14.007 0 00-13.312 9.65l-.673 2.06-2.094.562A8.005 8.005 0 006 30a8 8 0 008 8h8.135l2.484 4H14C7.373 42 2 36.627 2 30c0-5.55 3.768-10.22 8.886-11.592C13.238 11.205 20.01 6 28 6zm7 25a4 4 0 100 8 4 4 0 000-8z"/></svg>
</template>
<script>

export default {
  name: 'IconCloudParse',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
